// extracted by mini-css-extract-plugin
export default {"overlay":"Aw-z","bodyOpen":"Bw-z","content":"Cw-z","header":"Dw-z","close":"Ew-z","closeNoHeading":"Fw-z"};